import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu--subsidies--search-by-cities', class extends Controller {
  static targets = ['cityList']
  static values = {
    defaultRow: String,
  }

  connect() {
    // 初期表示は「あ行」を表示
    this.showRow(this.defaultRowValue)
  }

  // タブクリック時の処理
  switchTab(event) {
    const row = event.currentTarget.dataset.row
    this.showRow(row)
  }

  // 指定した行の市区町村リストを表示
  showRow(row) {
    // 全てのタブの選択状態をリセット
    this.element.querySelectorAll('.subsidies-search-by-cities__kana-tab').forEach((tab) => {
      tab.classList.remove('subsidies-search-by-cities__kana-tab--active')
    })

    // クリックされたタブをアクティブに
    this.element.querySelectorAll(`[data-row="${row}"]`).forEach((tab) => {
      if (tab.tagName === 'BUTTON') {
        tab.classList.add('subsidies-search-by-cities__kana-tab--active')
      }
    })

    // 全ての市区町村リストを非表示
    this.cityListTargets.forEach((list) => {
      list.classList.remove('subsidies-search-by-cities__table--active')
    })

    // 指定した行の市区町村リストを表示
    this.cityListTargets.forEach((list) => {
      if (list.dataset.row === row) {
        list.classList.add('subsidies-search-by-cities__table--active')
      }
    })
  }
})
